import { useEffect, useState } from "react";
import { breakpoint } from "../theme";

const MOBILE_MEDIA_QUERY = `(max-width: ${Number.parseInt(breakpoint.desktop, 10) - 1}px)`;

function getIsMobile() {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

    const onChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}